import { render, staticRenderFns } from "./TripSearch.vue?vue&type=template&id=04533d84&scoped=true&"
import script from "./TripSearch.vue?vue&type=script&lang=js&"
export * from "./TripSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04533d84",
  null
  
)

/* custom blocks */
import block0 from "./TripSearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports